module.exports = __webpack_public_path__ + "static/media/13.6521f1a7.jpg";